export default __webpack_public_path__ + "static/media/logo-dark.ec32bde0.png";